// SectionCard — container panel matching mockup-reference.html design.
// border: 1px solid border, borderRadius: 18px, padding: 28px 32px.
import React from 'react';

/**
 * @param {object} props
 * @param {string} props.title - Section heading
 * @param {string} [props.source] - Data-source caption shown right of the title
 * @param {React.ReactNode} props.children
 * @param {object} [props.style] - Override container styles
 */
export default function SectionCard({ title, source, children, style }) {
  return (
    <div style={{
      background: 'var(--theme-cardBg)',
      border: '1px solid var(--theme-border)',
      borderRadius: 18,
      padding: '28px 32px',
      transition: 'all 0.3s ease',
      ...style,
    }}>
      {title && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 20, gap: 12 }}>
          <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--theme-textSecondary)', flex: 1, minWidth: 0 }}>{title}</div>
          {source && (
            <div style={{ fontSize: 12, color: 'var(--theme-textTertiary)', fontFamily: 'var(--font-mono)', whiteSpace: 'nowrap' }}>
              {source}
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
